const NORWEGIAN_MONTH_NAMES = [
    'Januar',
    'Februar',
    'Mars',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Desember'
];

const MONTH_NAME_TO_NUMBER = NORWEGIAN_MONTH_NAMES.reduce((map, name, index) => {
    map[name.toLowerCase()] = index + 1;
    return map;
}, {});

/**
 * Parses dashboard month filter values (yyyy-MM, ISO date, or "Mai 2026") to yyyy-MM.
 */
export function parseYearMonthKey(value) {
    if (value == null || value === '') {
        return null;
    }
    const text = String(value).trim();
    if (/^\d{4}-\d{2}$/.test(text)) {
        return text;
    }
    const labelMatch = /^([A-Za-zÆØÅæøå]+)\s+(\d{4})$/.exec(text);
    if (labelMatch) {
        const month = MONTH_NAME_TO_NUMBER[labelMatch[1].toLowerCase()];
        if (month) {
            return `${labelMatch[2]}-${String(month).padStart(2, '0')}`;
        }
    }
    const date = new Date(text);
    if (!Number.isNaN(date.getTime())) {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
    }
    return null;
}

/**
 * Formats yyyy-MM as a Norwegian month label (e.g. "Mai 2026").
 */
export function formatYearMonthLabel(yearMonth) {
    const key = parseYearMonthKey(yearMonth);
    if (!key) {
        return yearMonth == null ? '' : String(yearMonth);
    }
    const [year, month] = key.split('-').map(Number);
    const monthName = NORWEGIAN_MONTH_NAMES[month - 1];
    if (!monthName) {
        return key;
    }
    return `${monthName} ${year}`;
}

export function formatYearMonthFilterItem(item) {
    if (!item || item.isAll || item.key === -1) {
        return item?.text ?? '';
    }
    const raw = item.text ?? item.value ?? item.key;
    if (raw == null) {
        return '';
    }
    return formatYearMonthLabel(raw);
}
